import React from 'react';
import PropTypes from 'prop-types';
import { callApp } from '@ifeng-fe/callapp';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import HiddenSeoTime, { VisibleSeoTime } from '../../../../../../common/seoUpdateTime';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isBig: PropTypes.bool,
        handleChangeFontSize: PropTypes.func,
        pageType: PropTypes.string,
    };

    handleClick = () => {
        const { isBig, handleChangeFontSize } = this.props;

        handleChangeFontSize(!isBig);
    };

    followHandle = () => {
        const { content } = this.props;

        callApp({
            docType: 'doc',
            pid: content.base62Id || '',
            kind: 'inter_pcsfbgzan01',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1513186619541',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8940',
        });
    };

    render() {
        const {
            content: { title, newsTime, createTime, updateTime, fhhAccountDetail, noffhFlag, hasCopyRight, subscribe },
            isBig,
            pageType,
        } = this.props;
        const isShowFollowButton = subscribe?.forbidFollow === 0;

        const props =
            !fhhAccountDetail.forbidJump && fhhAccountDetail.authorUrl
                ? {
                      href: fhhAccountDetail.authorUrl,
                      target: '_blank',
                  }
                : {};

        return (
            <header className={styles.caption}>
                {pageType !== 'short' && <h1>{title}</h1>}
                <div className={styles.box}>
                    <div className={styles.source_box}>
                        {fhhAccountDetail.logo ? (
                            <span
                                className={styles.wemediaImg}
                                style={{
                                    backgroundImage: `url(${fhhAccountDetail.logo})`,
                                    backgroundSize: 'contain',
                                }}>
                                {fhhAccountDetail.honorImg && (
                                    <img src={fhhAccountDetail.honorImg} className={styles.faceV} />
                                )}
                            </span>
                        ) : (
                            ''
                        )}
                        <div className={styles.info_box}>
                            <span className={styles.source}>
                                {!fhhAccountDetail.cateSource ? (
                                    <span className={styles.source}>
                                        {fhhAccountDetail.authorUrl ? (
                                            <a href={fhhAccountDetail.authorUrl} rel="medianame" target="_blank">
                                                {fhhAccountDetail.catename}
                                            </a>
                                        ) : (
                                            <span className={styles.txt} rel="medianame">{fhhAccountDetail.catename}</span>
                                        )}
                                    </span>
                                ) : (
                                    <span className={styles.source}>
                                        {noffhFlag ? (
                                            <a rel="medianame">{fhhAccountDetail.catename}</a>
                                        ) : (
                                            <a {...props} rel="medianame">{fhhAccountDetail.catename}</a>
                                        )}
                                    </span>
                                )}
                            </span>
                            <div className={styles.info}>
                                {fhhAccountDetail.originalName && (
                                    <span className={styles.original}>{fhhAccountDetail.originalName}</span>
                                )}
                                <VisibleSeoTime publishTime={createTime}>{newsTime}</VisibleSeoTime>
                                <HiddenSeoTime publishTime={createTime} updateTime={updateTime} />
                                {fhhAccountDetail?.lastArticleAddress && (
                                    <span>&nbsp;{fhhAccountDetail?.lastArticleAddress || ''}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    {hasCopyRight &&
                        isShowFollowButton && (
                            <div className={styles.follow} onClick={this.followHandle}>
                                <img
                                    src="https://x0.ifengimg.com/ucms/2022_05/2E72AF8B2980A7BBBD47CA1EE109EA38F25A6659_size4_w120_h56.png"
                                    alt=""
                                />
                            </div>
                        )}
                    <div className={`${styles.btn}`} onClick={this.handleClick}>
                        {isBig ? (
                            <img
                                className={styles.small}
                                src="https://x0.ifengimg.com/ucms/2022_05/1E375C72CA921F10B32B77E209AAA1A2BADBCA55_size4_w120_h56.png"
                                alt=""
                            />
                        ) : (
                            <img
                                className={styles.big}
                                src="https://x0.ifengimg.com/ucms/2022_05/5B312A57EB9917871E79169E07B3B1407C9244D5_size4_w120_h56.png"
                                alt=""
                            />
                        )}
                    </div>
                </div>
            </header>
        );
    }
}

export default errorBoundary(Caption);
